module.exports = __webpack_public_path__ + "static/media/Gerald Coombe.654cc2d7.jpg";